@if (selectedColumns) {
  <div class="d-none d-md-block table-container">
    <app-list-view-toolbar
      [columns]="columns"
      [isSticky]="isToolbarSticky"
      [columnDefinition]="columnDefinition"
      [preferencesKey]="preferencesKey"
      (columnsChanged)="ColumnChanged($event)"
    ></app-list-view-toolbar>
    <div class="scroll-x scroll-x-shadows" #scrollView>
      <table class="table table-hover">
        <thead #tableHeader>
          <tr>
            <th class="multiselect-menu-container no-padding-left">
              <div class="multiselect-header no-padding-left">
                <div class="select-box">
                  <astral-checkbox [control]="control" [showCaption]="false" variant="compact"></astral-checkbox>
                </div>
                @if (hasMenu) {
                  <div class="d-flex">
                    <div class="open-menu-btn" (mouseenter)="onMenuMouseEnter()" (mouseleave)="onMenuMouseLeave()">
                      <div class="flex-center">
                        <span class="circle-4 mr-1"></span><span class="circle-4 mr-1"></span><span class="circle-4"></span>
                      </div>
                      @if (showMenu) {
                        <div class="menu-container action-menu">
                          <div>
                            <span class="action-menu-pointer"></span>
                          </div>
                          <ul class="menu">
                            @for (definition of menuDefinition; track definition) {
                              <li>
                                <button class="menu-item" type="button" (click)="execute(definition.commandId, definition.contextId)">
                                  {{ definition.header | translate }}<i class="{{ definition.icon }}"></i>
                                </button>
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </th>
            @for (column of selectedColumns; track column) {
              @if (column.helpText) {
                <th
                  appTooltip="{{ column.helpText | translate }}"
                  tooltipPosition="above"
                  [dh-list-view-header]="column.id"
                  [canSort]="column.canSort"
                  (stateChange)="onStateChange($event)"
                  >
                  <span class="column-caption">{{ column.caption | translate }}</span>
                </th>
              }
              @if (!column.helpText) {
                <th
                  [dh-list-view-header]="column.id"
                  [canSort]="column.canSort"
                  (stateChange)="onStateChange($event)"
                  >
                  <span class="column-caption">{{ column.caption | translate }}</span>
                </th>
              }
            }
            <th class="column-header"></th>
          </tr>
        </thead>
        <tbody class="table-striped">
          @for (row of rows | slice: from : to; track row; let i = $index) {
            <tr appListViewItem [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
              <td>
                <div class="rowcount">
                  <astral-checkbox
                    [checked]="row.selected"
                    [disabled]="isSelectionDisabled(row)"
                    [showCaption]="false"
                    variant="compact"
                    (checkedChange)="onRowSelectionChanged(row, $event)"
                  ></astral-checkbox>
                  <span class="rowcount__number">{{ getRowNumber(i) }}</span>
                </div>
              </td>
              @for (column of selectedColumns; track column) {
                <td (click)="onRowClicked(row, $event)">
                  <dh-custom-view
                    [viewType]="column.viewType"
                    [value]="row.getValue(column)"
                    [helpText]="row.getHelpText(column)"
                    [isPhoneNumber]="column.isPhoneNumber"
                  ></dh-custom-view>
                </td>
              }
              <td></td>
              @if (contextMenuDefinition) {
                <app-context-menu
                  [context]="row.dataSource"
                  [smaller]="true"
                  [menuDefinition]="contextMenuDefinition"
                ></app-context-menu>
              }
            </tr>
          }
          @if (totalCount) {
            <tr class="list-summary">
              <td>{{ selectedItemsCount ? selectedItemsCount.toString() + '/' : '' }}{{ totalCount }}</td>
              @for (column of selectedColumns; track column) {
                <td>
                  @if (column.sum) {
                    @for (summary of sumValues(column); track $index) {
                      <div>{{ summary.displayValue }}</div>
                    }
                  }
                </td>
              }
              <td></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paging [resetOnTotalCountChange]="!rememberPagination" [itemsPerPage]="pageSize" [totalCount]="totalCount" [pageNumber]="currentPageNumber" (onPageChange)="pagingChanged($event)"></app-paging>
  </div>
  <div class="d-block d-md-none">
    @if (rows.length > 0) {
      <app-list-view-toolbar
        [columns]="columns"
        [columnDefinition]="columnDefinition"
        [preferencesKey]="preferencesKey"
        [isSticky]="isToolbarSticky"
        (columnsChanged)="ColumnChanged($event)"
      ></app-list-view-toolbar>
    }
    @if (isEmpty) {
      <p class="help-text">{{ 'COMMON.EMPTY_LIST' | translate }}</p>
    }
    @if (largeNumberOfItems) {
      <cdk-virtual-scroll-viewport
        [itemSize]="selectedColumns.length * 33.6 + 225"
        [minBufferPx]="25000"
        [maxBufferPx]="30000"
        class="scroll-port-m"
        >
        <div *cdkVirtualFor="let row of rows" class="entry-m" [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
          @if (contextMenuDefinition) {
            <div class="float-right">
              <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [alwaysVisible]="true"></app-context-menu>
            </div>
          }
          <astral-checkbox
            [checked]="row.selected"
            [disabled]="isSelectionDisabled(row)"
            [showCaption]="false"
            variant="compact"
            (checkedChange)="onRowSelectionChanged(row, $event)"
          ></astral-checkbox>
          <ul class="mobile-list-view" (click)="onRowClicked(row, $event)">
            @for (column of selectedColumns; track column) {
              @if (row.getValue(column)) {
                <li>
                  <div class="property-name-m">{{ column.caption | translate }}</div>
                  <dh-custom-view
                    [viewType]="column.viewType"
                    [value]="row.getValue(column)"
                    [helpText]="row.getHelpText(column)"
                    [isPhoneNumber]="column.isPhoneNumber"
                  ></dh-custom-view>
                </li>
              }
            }
          </ul>
        </div>
      </cdk-virtual-scroll-viewport>
    }
    @if (smallNumberOfItems) {
      @for (row of rows; track row) {
        <div class="entry-m" [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
          @if (contextMenuDefinition) {
            <div class="float-right">
              <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [alwaysVisible]="true"></app-context-menu>
            </div>
          }
          <astral-checkbox
            [checked]="row.selected"
            [disabled]="isSelectionDisabled(row)"
            [showCaption]="false"
            variant="compact"
            (checkedChange)="onRowSelectionChanged(row, $event)"
          ></astral-checkbox>
          <ul class="mobile-list-view" (click)="onRowClicked(row, $event)">
            @for (column of selectedColumns; track column) {
              @if (row.getValue(column)) {
                <li>
                  <div class="property-name-m">{{ column.caption | translate }}</div>
                  <dh-custom-view
                    [viewType]="column.viewType"
                    [value]="row.getValue(column)"
                    [helpText]="row.getHelpText(column)"
                    [isPhoneNumber]="column.isPhoneNumber"
                  ></dh-custom-view>
                </li>
              }
            }
          </ul>
        </div>
      }
    }
    <div class="multiselect-header-m">
      <div class="d-flex align-items-center w-100">
        <astral-checkbox [control]="control" [showCaption]="false" variant="compact"></astral-checkbox>
        @if (selectedItemsCount == 0) {
          <span>{{ 'NO_ITEMS_SELECTED_TEXT' | translate }}</span>
        }
        @if (selectedItemsCount == 1) {
          <span>{{ 'SINGLE_ITEM_SELECTED_TEXT' | translate }}</span>
        }
        @if (selectedItemsCount > 1) {
          <span>{{ 'PLURAL_ITEMS_SELECTED_TEXT' | translate: { count: selectedItemsCount } }}</span>
        }
      </div>
      <button class="open-menu-btn" [class.actions-active]="isActive" type="button" (click)="openMenu()">
        <span class="circle-4 mr-1"></span><span class="circle-4 mr-1"></span><span class="circle-4"></span>
      </button>
      <div class="position-relative">
        @if (showMenu) {
          <div class="menu-container action-menu">
            <ul class="menu">
              @for (definition of menuDefinition; track definition) {
                <li>
                  <button class="menu-item" type="button" (click)="execute(definition.commandId, definition.contextId)">
                    {{ definition.header | translate }}<i class="{{ definition.icon }}"></i>
                  </button>
                </li>
              }
            </ul>
            <div class="action-menu-pointer-container">
              <span class="action-menu-pointer"></span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
